
import { format, isSameDay, parseISO } from 'date-fns';

export const formatDate = (date: string | Date): string => {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return format(dateObj, 'MMM dd, yyyy');
};

export const formatShortDate = (date: string | Date): string => {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return format(dateObj, 'MMM d');
};

export const isToday = (date: string | Date): boolean => {
  if (!date) return false;
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return isSameDay(dateObj, new Date());
};

export const isSpecialDayToday = (specialDay: { date: string, name: string }): boolean => {
  if (!specialDay?.date) return false;
  
  // Check if this special day is today (ignore year)
  const today = new Date();
  const specialDate = parseISO(specialDay.date);
  
  return (
    today.getDate() === specialDate.getDate() && 
    today.getMonth() === specialDate.getMonth()
  );
};

export const getUpcomingSpecialDays = (specialDays: { id: string, name: string, date: string }[], daysAhead = 7): { id: string, name: string, date: string }[] => {
  if (!specialDays?.length) return [];
  
  const today = new Date();
  const maxDate = new Date();
  maxDate.setDate(today.getDate() + daysAhead);
  
  return specialDays
    .filter(day => day.date)
    .filter(day => {
      const specialDate = parseISO(day.date);
      
      // Create date with current year to check if it's upcoming
      const thisYearDate = new Date(
        today.getFullYear(),
        specialDate.getMonth(),
        specialDate.getDate()
      );
      
      // If the date has already passed this year, check for next year
      if (thisYearDate < today) {
        thisYearDate.setFullYear(today.getFullYear() + 1);
      }
      
      return thisYearDate <= maxDate && thisYearDate >= today;
    })
    .sort((a, b) => {
      const dateA = parseISO(a.date);
      const dateB = parseISO(b.date);
      
      // Create dates with current year
      const thisYearDateA = new Date(
        today.getFullYear(),
        dateA.getMonth(),
        dateA.getDate()
      );
      const thisYearDateB = new Date(
        today.getFullYear(),
        dateB.getMonth(),
        dateB.getDate()
      );
      
      // If the date has already passed this year, check for next year
      if (thisYearDateA < today) {
        thisYearDateA.setFullYear(today.getFullYear() + 1);
      }
      if (thisYearDateB < today) {
        thisYearDateB.setFullYear(today.getFullYear() + 1);
      }
      
      return thisYearDateA.getTime() - thisYearDateB.getTime();
    });
};
